import React, {FC, useRef, useState} from "react";
import { ReactComponent as DownArrow } from "../assets/svg/down-arrow.svg";
import { selectChartZoom, setChartZoom, setDates, setZoom } from "../store/chart/chartSlice";
import { ChartZoom } from "../store/chart/types";
import { useAppDispatch, useAppSelector } from "../store/hooks";

const itemStyles = "w-full h-[1.5rem] flex flex-row pt-1"

const Dropdown: FC<{chart: string}> = ({chart}) => {
    const dropMenu = useRef<HTMLDivElement>(null);
    const [currentSelection, setCurrentSelection] = useState<string>("1 week");
    const chartZoom = useAppSelector(selectChartZoom);
    const dispatch = useAppDispatch();

    const options = [
        { value: "day", label: "1 day"},
        { value: "week", label: "1 week"},
        { value: "month", label: "1 month"},
        // { value: "half-year", label: "6 months"},
        // { value: "year", label: "1 year"},
        // { value: "all-time", label: "All time"}
    ]

    const handleInputClick = () => {
        if(dropMenu.current !== null) {
            if(dropMenu.current.classList.contains("block")){
                dropMenu.current.classList.remove("block");
                dropMenu.current.classList.add("hidden");
            } else {
                dropMenu.current.classList.remove("hidden");
                dropMenu.current.classList.add("block");
            }
        }
        
    }

    const handleItemClick = (label: string, value: string) => {
        let newChartZoom = {} as ChartZoom;
        newChartZoom.dailyBar = chartZoom.dailyBar;
        newChartZoom.dailyLine = chartZoom.dailyLine;
        newChartZoom.portLine = chartZoom.portLine;
        newChartZoom.worthLine = chartZoom.worthLine;

        if(chart === "portLine") {
            newChartZoom.portLine = value;
        } else if (chart === "worthLine") {
            newChartZoom.worthLine = value;
        } else if (chart === "dailyBar") {
            newChartZoom.dailyBar = value;
        } else if (chart === "dailyLine") {
            newChartZoom.dailyLine = value;
        }
        setCurrentSelection(label);
        dispatch(setChartZoom(newChartZoom));
        dispatch(setDates(value));
    }


    return (
        <div id="drop-contain" className="relative h-[2rem] w-[7rem] bg-zinc-700 rounded-2xl text-white">
            <div id="drop-input"  onClick={handleInputClick} className="p-2 flex items-center justify-between w-full h-full" style={{userSelect: "none"}}>
                {currentSelection}
                <DownArrow className="fill-white"/>
                <div id="drop-menu" ref={dropMenu} className="bg-zinc-700 w-[80%] hidden">
                    {options.map((option) => (
                        <div id="drop-item" key={option.value} className={itemStyles} onClick={() => handleItemClick(option.label, option.value)}>{option.label}</div>
                        ))}
                    
                </div>
            </div>
        </div>

    )
}

export default Dropdown;